// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-add {
   background: darkgreen;
   color: white;
}

.form-add-recipients {
   margin-right: 50px;
}

.input-name {
   margin-right: 10px;
}

.btn-search {
   margin-right: 100px;
}

::ng-deep .mat-accordion > .mat-expansion-panel-spacing:last-child {
   margin-bottom: 10px !important;
}
.desc {
   padding: 5px 0 5px 0;
   color: #999;
   font-size: 12px;
}
.name,.desc {
   height:auto;
   word-wrap: break-word;
   position: relative;
   white-space: pre-line;
   line-height: 1.1;
}
.name{
   padding-top: 10px!important;
}
.select-workflow{
   margin: 10px 10px 10px 10px;
   width: 20%;
}
.search-workflow{
   top: 0;
   padding-left:10px!important;
   padding-right:10px!important;
   position : sticky!important;
   width: 100%;
   background: white;
   height: 100%;
   z-index: 1;
}
.name{
   padding-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/mail-flow/add-recipients/add-recipients.component.css"],"names":[],"mappings":"AAAA;GACG,qBAAqB;GACrB,YAAY;AACf;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,8BAA8B;AACjC;AACA;GACG,oBAAoB;GACpB,WAAW;GACX,eAAe;AAClB;AACA;GACG,WAAW;GACX,qBAAqB;GACrB,kBAAkB;GAClB,qBAAqB;GACrB,gBAAgB;AACnB;AACA;GACG,2BAA2B;AAC9B;AACA;GACG,2BAA2B;GAC3B,UAAU;AACb;AACA;GACG,MAAM;GACN,2BAA2B;GAC3B,4BAA4B;GAC5B,2BAA2B;GAC3B,WAAW;GACX,iBAAiB;GACjB,YAAY;GACZ,UAAU;AACb;AACA;GACG,gBAAgB;AACnB","sourcesContent":[".btn-add {\n   background: darkgreen;\n   color: white;\n}\n\n.form-add-recipients {\n   margin-right: 50px;\n}\n\n.input-name {\n   margin-right: 10px;\n}\n\n.btn-search {\n   margin-right: 100px;\n}\n\n::ng-deep .mat-accordion > .mat-expansion-panel-spacing:last-child {\n   margin-bottom: 10px !important;\n}\n.desc {\n   padding: 5px 0 5px 0;\n   color: #999;\n   font-size: 12px;\n}\n.name,.desc {\n   height:auto;\n   word-wrap: break-word;\n   position: relative;\n   white-space: pre-line;\n   line-height: 1.1;\n}\n.name{\n   padding-top: 10px!important;\n}\n.select-workflow{\n   margin: 10px 10px 10px 10px;\n   width: 20%;\n}\n.search-workflow{\n   top: 0;\n   padding-left:10px!important;\n   padding-right:10px!important;\n   position : sticky!important;\n   width: 100%;\n   background: white;\n   height: 100%;\n   z-index: 1;\n}\n.name{\n   padding-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
